import { useState } from "react";
import { useSignInEmailPassword } from "@nhost/react";
import { Link, Navigate } from "react-router-dom";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const {
    signInEmailPassword,
    isLoading,
    isSuccess,
    needsEmailVerification,
    isError,
    error,
  } = useSignInEmailPassword();

  const handleOnSubmit = (e) => {
    e.preventDefault();
    signInEmailPassword(email, password);
  };

  if (isSuccess) {
    return <Navigate to="/" replace={true} />;
  }

  const disableForm = isLoading || needsEmailVerification;

  return (
    <div className="flex-col  mt-11 bg-neutral-400  w-96 ml-96 h-96 shadow-md rounded-l-lg shadow-black    ">
      <div className="flex-col  mt-11 bg-slate-700 ">
        {needsEmailVerification ? (
          <p>
            Please check your mailbox and follow the verification link to verify
            your email.
          </p>
        ) : (
          <form onSubmit={handleOnSubmit}>
            <div>
              <h2 className=" mx-10 mb-5 font-medium text-lime-400  ">
                {" "}
                Enter Email
              </h2>
              <input
                className="w-full outline-none px-20   font-medium  bg-neutral-400 "
                type="email"
                label="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={disableForm}
                required
              />
            </div>
            <div>
              <h2 className=" mx-10 mb-5 font-medium text-lime-400 ">
                {" "}
                Enter Password
              </h2>
              <input
                className="w-full outline-none px-20   font-medium bg-neutral-400  "
                type="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={disableForm}
                required
              />
            </div>

            <button className="my-7 " type="submit" disabled={disableForm}>
              {isLoading ? "Loading" : "Sign in"}
            </button>

            {isError ? <p>{error?.message}</p> : null}
          </form>
        )}
      </div>

      <p >
        No account yet? <Link className="text-cyan-700 " to="/sign-up">Sign up</Link>
      </p>
    </div>
  );
};

export default SignIn;
